//#region src/workspace.ts
/** Reserved workspace tags that cannot be set by users directly */
const WORKSPACE_RESERVED_TAGS = [
	"system",
	"lobby",
	"community"
];
const RPC_EVENT_MEMBER_ADDED_IDENT = "org.aimystic.modules.events.MemberAdded";
const RPC_EVENT_MEMBER_REMOVED_IDENT = "org.aimystic.modules.events.MemberRemoved";
const RPC_EVENT_MEMBER_ADDED = {
	ident: RPC_EVENT_MEMBER_ADDED_IDENT,
	description: "Event emitted when a member is added to a workspace",
	params: [{
		name: "member",
		type: "object",
		description: "The member that was added"
	}]
};
const RPC_EVENT_MEMBER_REMOVED = {
	ident: RPC_EVENT_MEMBER_REMOVED_IDENT,
	description: "Event emitted when a member is removed from a workspace",
	params: [{
		name: "workspaceId",
		type: "string",
		description: "The workspace ID"
	}, {
		name: "userId",
		type: "string",
		description: "The user ID that was removed"
	}]
};
const RPC_EVENT_WORKSPACE_ACCESS_GRANTED_IDENT = "org.aimystic.modules.events.WorkspaceAccessGranted";
const RPC_EVENT_WORKSPACE_ACCESS_GRANTED = {
	ident: RPC_EVENT_WORKSPACE_ACCESS_GRANTED_IDENT,
	description: "Event emitted when a user is granted access to a workspace",
	params: [{
		name: "workspaceId",
		type: "string",
		description: "The workspace ID"
	}, {
		name: "userId",
		type: "string",
		description: "The user ID that was granted access"
	}]
};
const RPC_EVENT_WORKSPACE_ACCESS_DENIED_IDENT = "org.aimystic.modules.events.WorkspaceAccessDenied";
const RPC_EVENT_WORKSPACE_ACCESS_DENIED = {
	ident: RPC_EVENT_WORKSPACE_ACCESS_DENIED_IDENT,
	description: "Event emitted when a user's access request to a workspace is denied",
	params: [{
		name: "workspaceId",
		type: "string",
		description: "The workspace ID"
	}, {
		name: "userId",
		type: "string",
		description: "The user ID whose access was denied"
	}]
};
const WORKSPACE_LIBRARY_SERVICE_IDENT = "org.aimystic.modules.services.workspaceLibraryService";
const RPC_EVENT_WORKSPACE_CREATED_IDENT = "org.aimystic.modules.events.WorkspaceCreated";
const RPC_EVENT_WORKSPACE_UPDATED_IDENT = "org.aimystic.modules.events.WorkspaceUpdated";
const RPC_EVENT_WORKSPACE_DELETED_IDENT = "org.aimystic.modules.events.WorkspaceDeleted";
const RPC_EVENT_WORKSPACE_CREATED = {
	ident: RPC_EVENT_WORKSPACE_CREATED_IDENT,
	description: "Event emitted when a workspace is created",
	params: [{
		name: "workspace",
		type: "object",
		description: "The workspace that was created"
	}]
};
const RPC_EVENT_WORKSPACE_UPDATED = {
	ident: RPC_EVENT_WORKSPACE_UPDATED_IDENT,
	description: "Event emitted when a workspace is updated",
	params: [{
		name: "workspace",
		type: "object",
		description: "The workspace that was updated"
	}]
};
const RPC_EVENT_WORKSPACE_DELETED = {
	ident: RPC_EVENT_WORKSPACE_DELETED_IDENT,
	description: "Event emitted when a workspace is deleted",
	params: [{
		name: "workspaceId",
		type: "string",
		description: "The ID of the workspace that was deleted"
	}]
};

//#endregion
export { RPC_EVENT_MEMBER_ADDED, RPC_EVENT_MEMBER_ADDED_IDENT, RPC_EVENT_MEMBER_REMOVED, RPC_EVENT_MEMBER_REMOVED_IDENT, RPC_EVENT_WORKSPACE_ACCESS_DENIED, RPC_EVENT_WORKSPACE_ACCESS_DENIED_IDENT, RPC_EVENT_WORKSPACE_ACCESS_GRANTED, RPC_EVENT_WORKSPACE_ACCESS_GRANTED_IDENT, RPC_EVENT_WORKSPACE_CREATED, RPC_EVENT_WORKSPACE_CREATED_IDENT, RPC_EVENT_WORKSPACE_DELETED, RPC_EVENT_WORKSPACE_DELETED_IDENT, RPC_EVENT_WORKSPACE_UPDATED, RPC_EVENT_WORKSPACE_UPDATED_IDENT, WORKSPACE_LIBRARY_SERVICE_IDENT, WORKSPACE_RESERVED_TAGS };
//# sourceMappingURL=workspace.js.map